import React from 'react';
import { project } from '../data';
import  Counters  from './Counters';
import AOS from 'aos';
import "aos/dist/aos.css";

const Counter = () => {
  AOS.init();
  return (
    <>
  <div className=''>
        <div className='text-accent  flex md:flex-cols lg:flex-row justify-evenly lg:space-x-14 text-[38px] items-center relative'>
          {project.map((item) => (
            <div className='box' data-aos='zoom-in'>
              <i className='text-accent m-2'>{item.icon}</i>
            </div>
          ))}
        </div>
      </div>
      <div className=''>
      <Counters />
      </div>
    </>
  )
}

export default Counter